import { Component, ViewChild, ElementRef, AfterViewInit, HostListener, Input , ChangeDetectorRef, OnDestroy, OnInit} from '@angular/core';
import { ScrollService } from 'src/app/services/scroll.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Restaurant } from 'src/interfaces/restaurant.model';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-menu-header-image',
    templateUrl: './menu-header-image.component.html',
    styleUrls: ['./menu-header-image.component.css'],
    standalone: false
})
export class MenuHeaderImageComponent implements OnInit, AfterViewInit, OnDestroy{
  constructor(
    private cdr: ChangeDetectorRef, 
    private imageCache: ImageCacheService,
    private scrollService: ScrollService,
    private dataService: DataService
  ) {
    this.transformStyle = 'scale(1.5)';
    this.restaurant = this.dataService.restaurant;
  }

  @ViewChild('restaurantContainer', { static: true })
  restaurantContainer!: ElementRef;
  // @Input() restaurant: Restaurant | null = null;
  restaurant: Restaurant | null;

  storeTitle: string = '';

  // Opacity
  opacity = 1;
  
  // Logo styles
  initLogoSize = 0;
  logoSize: number | null = null;
  
  // Image
  initImageHeight = 0;
  imageHeight: number | null = null;
  imageSrc: string | null = null;
  logoSrc: string | null = null;

  // Setting styles
  offsetY = 0.20;
  remainderHight = 0;
  transformStyle: string;

  // Parallax
  parallaxOffset: number = 0;
  parallaxHight = 0;
  isParralaxVisible = false;
  isScrollEnabled = true;
  private destroy$ = new Subject<void>();

  searchPlaceholder = 'Поиск';

  ngOnInit(): void {
    this.isParralaxVisible = true;
    this.scrollService.scrollEnabled$
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      enabled => this.isScrollEnabled = enabled
    );

    // Image
    if (this.restaurant?.image?.trim()) {
      this.imageCache.getImage(this.restaurant.image).then(src => {
        this.imageSrc = src;
      });
    }

    // Logo
    if (this.restaurant?.logo?.trim()) {
      this.imageCache.getImage(this.restaurant.logo).then(src => {
        this.logoSrc = src;
      });
    }
  }

  ngAfterViewInit() {
    // Получаем высоту экрана
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    // Получаем ширину блока с картинкой
    const width = document.querySelector('#header')!.clientWidth;
    this.setImageStyles(width);
    this.setLogoStyles(width);
    // console.log('MenuHeaderComponent | ngAfterViewInit() | vh:', vh, 'width:', width);
    this.cdr.detectChanges(); 
    // console.log('MenuHeaderComponent | ngAfterViewInit() | initialHeight:', this.imageHeight);
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event: any): void {
  //   const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  //   // console.log('MenuHeaderComponent | onResize() | vh:', vh);
  //   this.setImageStyles(vh);
  // }

  private setImageStyles(width: number): void {
    this.initImageHeight = (width / 10) * 6;
    this.imageHeight = this.initImageHeight;
    this.parallaxHight = this.initImageHeight;
    this.remainderHight = this.initImageHeight - this.initImageHeight * this.offsetY;
  }
  // Logo styles
  private setLogoStyles(width: number): void {
    this.initLogoSize = width / 4;
    this.logoSize = this.initLogoSize;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.isScrollEnabled) {
      return;
    }

    // Прокрутка страницы
    const currentScroll = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (currentScroll > this.initImageHeight) {
      this.isParralaxVisible = false;
      return;
    } else {
      this.isParralaxVisible = true;
    }
    // console.log('MenuHeaderComponent | onWindowScroll() | scrollY:', currentScroll);
    
    // Процент прокрутки относительно высоты изображения
    const scrollPercentage = currentScroll / this.initImageHeight;
  
    // Текущий размер логотипа
    this.logoSize = this.initLogoSize * (1 - scrollPercentage);

    // Высота изображения к которой не применяется прозрачность
    let viewArea = this.initImageHeight - this.remainderHight;

    this.parallaxHight = this.initImageHeight - ( window.scrollY /2);
    // console.log('MenuHeaderComponent | onWindowScroll() | imageHeight:', this.imageHeight);

    // Изображение в шапке, а не fixed: сдвиг вниз на 0.45 прокрутки — на
    // экране оно уходит вверх в 0.55 скорости страницы, как раньше
    this.parallaxOffset = currentScroll * 0.45;

    // Прозрачность
    if (scrollPercentage > this.offsetY) {
      // Процент прозрачности
      const opacityPercentage = (currentScroll - viewArea) / this.remainderHight;
      this.opacity = Math.max((1 - opacityPercentage * 2), 0);
      // console.log('MenuHeaderComponent | onWindowScroll() | opacity:', this.opacity);
    } else {
      this.opacity = 1;
      const transformPercentage = currentScroll / viewArea;
      this.transformStyle = `scale(1.${1-transformPercentage})`;
      // console.log('MenuHeaderComponent | onWindowScroll() | transform:', this.transformStyle);
    }

    this.isParralaxVisible  = (this.opacity > 0);

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
